















































import { Component, Vue } from "vue-property-decorator";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import { TaxObligationDocumentType } from "@/dto/tax/TaxObligationDTO";
import { TaxObligationDocumentPayload } from "@/dto/tax/TaxObligationPayload";
import TaxObligationService from "@/services/TaxObligationService";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import FileMetaDTO from "@/dto/files/FileMetaDTO";

@Component({
  components: {
    PortalInput,
    PortalSelect,
    SingleFileHolder
  }
})
export default class AddTaxObligationDocumentModal extends Vue {
  private taxObligationId: number | null = null;
  private form: {
    type: TaxObligationDocumentType | null,
    comment: string | null,
    file: FileMetaDTO | null
  } = {
    type: TaxObligationDocumentType.PAYROLL_DETAILS,
    comment: null,
    file: null
  };

  get typeOptions() {
    return Object.values(TaxObligationDocumentType).map(val =>
      SelectOption.builder()
        .title(this.$t(`tax_calendar.document_types.${val}`).toString())
        .value(val)
        .build()
    );
  }

  get isCommentRequired(): boolean {
    return this.form.type === TaxObligationDocumentType.OTHER;
  }

  beforeOpen(event: any) {
    this.taxObligationId = event.params.taxObligationId;
    this.form = {
      type: TaxObligationDocumentType.PAYROLL_DETAILS,
      comment: null,
      file: null
    };
    this.$validator.reset();
  }

  closeModal() {
    this.$modal.hide("add-tax-obligation-document-modal");
  }

  get isValid(): boolean {
    const commonValid = !!(this.form.type && this.form.file);
    if (this.isCommentRequired) {
      return commonValid && !!this.form.comment;
    }
    return commonValid;
  }

  async submit() {
    const valid = await this.$validator.validateAll();
    if (!valid || !this.taxObligationId || !this.form.file || !this.form.type) return;

    const payload: TaxObligationDocumentPayload = {
      type: this.form.type,
      comment: this.form.comment,
      fileId: this.form.file.id
    };

    Application.startLoading();
    TaxObligationService.addDocument(this.taxObligationId, payload).then(
      () => {
        Application.stopLoading();
        this.$emit("added");
        this.closeModal();
      },
      err => {
        Application.stopLoading();
        processError(err, this);
      }
    );
  }
}
